/* eslint-disable */
import React, { useEffect, useRef, useState } from "react";
import * as API from '../../framework/API/api'
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ENTITYNAME, PUBLISHING_SOURCE, MEDIACATEGORIES, OTTROUTETYPE, ASSETTYPE, MODULE, LOGEVENT, LOCALSTORAGE_KEY, ACCESS_LEVEL, PLATFORMTYPE, BA_ACTION, MEDIA_TRANSMISSION } from "../../framework/constant/constant";
import { CardList } from "../../components/CardList";
import { FixedSidebarWithIcons } from "../../components/FixedSidebarWithIcons";
import SeriesDetailForm from "./SeriesDetailForm";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import SeasonMetaDataEditForm from "./SeasonMetaDataEditForm";
import { EditPageHeader } from "../../components/EditPageHeader";
import MediaEpisodePublishingEditForm from "./MediaEpisodePublishingEditForm";
import { toast } from 'react-toastify';
import { useTranslation } from "../../locale/useTranslation";
import MediaEpisodeAssetEditForm from "./MediaEpisodeAssetEditForm";
import moment from "moment";
import IsShortMediaCollectionSelection from "../../framework/forms/IsShortMediaCollectionSelection";
import RoundButton from "../../framework/forms/helpercomponents/buttons/RoundButton";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import DeleteRoundButton from "../../framework/forms/helpercomponents/buttons/DeleteRoundButton";
import { ConfirmAlert, ConfirmDeleteAlert } from "../../ConfirmAlert";
import { DataHelper } from "../../framework/helper/DataHelper";
import { utility } from "../../framework/utility/utilityProvider";
import BossAssistantIcon from "./component/BossAssistantIcon";

export const SeriesEditForm = (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const lang = useTranslation();
  const { SID } = useParams();
  const user = utility.getValue(LOCALSTORAGE_KEY.userData);
  const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);

  let blankDataItem = {
    SID: SID,
    Title: '',
    Content: {},
    Description: '',
    ImageUrl: '',
    Synopsis: '',
    Archive: false,
    Posters: [],
    Languages: [],
    Keywords: '',
    PGRating: {},
    ImageUrl: 'https://i.postimg.cc/j5PsF5jZ/defaultmovie.png',
    SeasonNumber: 1,
    IsLive: false,
    Genre: [],
    SubGenre: [],
    Transmission: { _id: MEDIA_TRANSMISSION.READY, Description: utility.getKeyByValue(MEDIA_TRANSMISSION, MEDIA_TRANSMISSION.READY) },
    Categories: []
  }

  const [seriesEntity, setSeriesEntity] = useState(
    location.state && location.state.isFromAddProgram && location.state.dataItem ?
      { ...blankDataItem, ...location.state.dataItem } : blankDataItem);

  const [season, setSeason] = useState([]);
  const [tabNumber, setTabNumber] = React.useState("1");

  const isAssestID = utility.isNumeric(SID) == false;
  const isEdit = isAssestID || SID > 0 ? true : false;
  const [openSeason, setOpenSeason] = useState(isEdit);
  const [isLoadedEdit, setIsLoadedEdit] = useState(false);
  const [mediaEpisodeEntity, setMediaEpisodeEntity] = useState({});
  const [seriesPublishings, setSeriesPublishings] = useState([]);
  const [seriesOffers, setSeriesOffers] = useState([]);

  const [mediaCategory, setMediaCategory] = useState([]);
  const [removedMedia, setRemovedMedia] = useState([]);
  const [removedOffers, setRemovedOffers] = useState([]);
  const [assetDataItem, setAssetDataItem] = useState({});

  const [createSeasonEpisode, setCreateSeasonEpisode] = useState(
    location.state && location.state.isFromAddProgram && location.state.createSeasonEpisode ?
      location.state.createSeasonEpisode : []
  );

  const [mediaOpen, setMediaOpen] = useState(false);
  const [isArchiveChanged, setIsArchiveChanged] = useState(false);
  const [selectedAttachedMedia, setSelectedAttachedMedia] = useState([]);

  const [imagePotraitImageFiles, setPotraitImageFiles] = useState(new Set());
  const [imageLandscapeImageFiles, setLandscapeImageFiles] = useState(new Set());

  //
  const [openPublishingDialog, setOpenPublishingDialog] = useState(false);
  const [defaultDealRight, setDefaultDealRight] = useState({});
  const [publishingDialogTitle, setPublishingDialogTitle] = useState(null);

  const [genres, setGenres] = useState([]);
  const [pgRatings, setPGRatings] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [isManualAssetId, setIsManualAssetId] = useState(false);
  const offerRef = useRef()
  const [offers, _setOffers] = useState([]);
  const setOffers = (data) => {
    offerRef.current = data;
    _setOffers(data)
  }

  const customeModelFields = {
    Title: "Title",
    Description: "Description",
    PosterURL: "ImageUrl",
    ThirdLine: "SeasonNumber"
  }

  useEffect(() => {
    loadcombo();
    if (isEdit) {
      loadEditData();
    } else {
      //in new it should be loaded without server fretching data
      setIsLoadedEdit(true);
    }
  }, [SID])

  const loadcombo = async () => {
    let mediaCategory = await API.getDataLookup(ENTITYNAME.MediaCategory);
    setMediaCategory(mediaCategory.data);
    let genreRes = await API.getDataLookup(ENTITYNAME.Genre);
    setGenres(genreRes.data);
    let pgRatingRes = await API.getDataLookup(ENTITYNAME.PGRating);
    setPGRatings(pgRatingRes.data);
    let languageRes = await API.getDataLookup(ENTITYNAME.Language);
    setLanguages(languageRes.data);
    let offerRes = await API.getDataLookup(ENTITYNAME.OFFER, { sort: { SID: 1 } });
    setOffers(offerRes.data)
  }

  const handleTabChange = (event, newValue) => {
    setTabNumber(`${newValue}`);
  };

  const loadEditData = async () => {

    let res = { message: "Not Valid", success: false };

    if (isAssestID) {
      res = await API.getEntityfromAssestID(ENTITYNAME.Series, SID);
    }
    else {
      res = await API.getEntity(ENTITYNAME.Series, SID);
    }

    if (!res.success) {
      toast.error(res.message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return;
    }

    let season = await API.getData(ENTITYNAME.Season, { query: ["Series_Id", "=", res.data._id] });
    console.log(season.data)

    if (season.success) {
      let seasonData = [...season.data].map((item) => { return { ...item, SeasonNumber: "Season: " + item.SeasonNumber } });
      setSeason(seasonData);
    }

    setSeriesEntity({
      ...blankDataItem, ...res.data,
      Transmission: res?.data?.Transmission ? { _id: res?.data?.Transmission, Description: utility.getKeyByValue(MEDIA_TRANSMISSION, res?.data?.Transmission) } : { _id: MEDIA_TRANSMISSION.READY, Description: utility.getKeyByValue(MEDIA_TRANSMISSION, MEDIA_TRANSMISSION.READY) }
    });
    setIsLoadedEdit(true);
    setMediaEpisodeEntity(res.data);

    //load asset details
    if (res.data.IsOttAsset) {

      let assetRes = await API.getData(ENTITYNAME.OttAsset, { query: [['Source._id', '=', res.data._id], ['Source.entityName', '=', 'series']] });
      console.log(assetRes);
      if (assetRes.data && assetRes.data.length > 0) {
        [
          setAssetDataItem({ ...assetRes.data[0], IsOttAsset: res.data.IsOttAsset })
        ]
      }
    }

    //load attached media
    let attachedMedia = await API.getData(ENTITYNAME.MediaEpisode, { query: ['Media._id', '=', res.data._id.toString()] });
    setSelectedAttachedMedia(attachedMedia.data);

    // fetching deal rights
    let mediaDealRights = await API.getData(ENTITYNAME.MediaDealRights, {
      query: ["media_id", "=", res.data._id.toString()],
    });
    let offers = await API.getData(ENTITYNAME.ASSET_OFFER_LINK, {
      query: ["media_id", "=", res.data._id.toString()],
    });
    let tempDealRightsData = mediaDealRights.data ?? [];
    if (mediaDealRights.data.length > 0) {
      tempDealRightsData = mediaDealRights.data.map((obj, index) => { return { ...obj, index: index }})
    }

    let tempMediaOfferData = offers.data ?? [];
    if (offers.data.length > 0) {
      tempMediaOfferData = offers.data.map((obj, index) => { return { ...obj, index: index,
        Offer: offerRef.current.find((x) => x._id == obj.Offer_id) 
      }})
    }

    setSeriesPublishings(tempDealRightsData ?? []);
    setSeriesOffers(tempMediaOfferData ?? []);

  };

  const setMataData = (data) => {
    setSeriesEntity({ ...seriesEntity, ...data });
  }

  const createNewSeasonEpisode = async (seriesId, data) => {

    if (data.SID == 0 && createSeasonEpisode.length > 0) {
      let seasonData = {
        seriesId: seriesId,
        seasons: createSeasonEpisode,
        customTitle: seriesEntity.CustomTitle
      }

      console.log("seasonData");
      console.log(seasonData);

      //Creating Seasons and Episodes
      let response = await API.createSeriesSeasons(seasonData);

      console.log(response);

      if (!response.success) {
        toast.error(response.message, {
          position: toast.POSITION.TOP_RIGHT
        });
        return null;
      } else {

        //MAINTAING LOGS FOR NEW CREATED SEASON AND EPISODES from SERIES
        if (response?.success && response?.data?.MediaEpisode.length > 0) {
          response?.data?.MediaEpisode.forEach((obj) => {
            obj?.data.forEach((x) => {
              let logData = { event: LOGEVENT.CREATE_EPISODE, module: MODULE.EPISODE, data: x?.data, message: 'Create Episode' };
              API.SaveLogs(logData);
            })
          });
        }

        if (response?.success && response?.data?.Season?.length > 0) {
          response?.data?.Season?.forEach((obj) => {
            let logData = { event: LOGEVENT.CREATE_SERIES, module: MODULE.MEDIA_EPISODE_SEASON, data: obj?.data, message: 'Create Media Episode Series' };
            API.SaveLogs(logData);
          });
        }
        return response;
      }
    }
    return null;

  }

  const saveArchiveChange = async () => {
    if (isArchiveChanged && seriesEntity.SID > 0) {
      console.log('------here------')
      await API.onChangeArchiveInSeriesSeason({
        _id: seriesEntity._id,
        archive: seriesEntity.Archive,
        entityName: ENTITYNAME.Series
      })
      setIsArchiveChanged(false);
    }
  }

  //SAVE AND UPDATE DEFAULT MEDIA DEAL RIGHTS
  const setDefaultDealRights = async () => {

    setPublishingDialogTitle("Please create deal rights first")
    handleTabChange({}, 2);
    setOpenPublishingDialog(true);

    //FETCH DEFAULT DEAL RIGHTS
    let resDefaultDealRights = await API.getData(ENTITYNAME.UserDefaultDealRights, { query: [["user_id", "=", user._id]] });
    if (resDefaultDealRights.success && resDefaultDealRights.data.length > 0) {

      setDefaultDealRight({
        ...resDefaultDealRights?.data[0],
        Publishing: {
          ...resDefaultDealRights?.data[0].Publishing,
          PublishingSource: PUBLISHING_SOURCE.Series
        }
      });
    } else {
      return;
    }
  }

  const updateDefaultDealRights = async () => {

    let newDefaultDealRight = seriesPublishings.find((x) => x.IsDefault);

    //FETCH DEFAULT DEAL RIGHTS
    if (newDefaultDealRight) {

      delete newDefaultDealRight.IsDefault;

      let updateData = {
        user_id: user._id,
        Publishing: newDefaultDealRight
      }

      if (Object.keys(defaultDealRight).length > 0) updateData._id = defaultDealRight._id;

      await API.saveData(ENTITYNAME.UserDefaultDealRights, updateData);

    }

  }

  const saveOffers = async (series) => {
    let offerData = [...seriesOffers];

    offerData.forEach((x) => {
      x.ContractTitle = {
        media_id : series?._id,
        Title : series?.Title,
        AssetId : series?.AssetId
      }
      x.media_id = series?._id,
      x.Offer_id = typeof x.Offer == 'object' ? x.Offer._id : x.Offer_id,
      x.source_id = series._id

      delete x.Offer
    });

    await API.updateOffers(series, removedOffers, offerData, PUBLISHING_SOURCE.Series);

    //LOAD OFFERS
    let tempMediaOfferData = [...seriesOffers] ?? [];
    if (seriesOffers.length > 0) {
      tempMediaOfferData = seriesOffers.map((obj, index) => { return { ...obj, index: index,
        Offer: offerRef.current.find((x) => x._id == obj.Offer_id) 
      }})
    }

    setSeriesOffers(seriesOffers);

  }


  const onSave = async () => {

    let localSeriesEntity = { ...seriesEntity };

    const series_id = localSeriesEntity._id;

    let data = DataHelper.saveSeriesEntity({ ...localSeriesEntity, SID: parseInt(localSeriesEntity.SID) }, mediaCategory, assetDataItem.IsOttAsset, localSeriesEntity?.ImageUrl);

    if (data?._id?.toString()?.length > 0) {
      delete data?._id
    }

    if (assetDataItem.IsOttAsset && !isValidAsset()) {
      return;
    }

    //PUT MEDIA RIGHTS VALIDATION HERE
    // if(user && user?.Channels?.length > 1 && seriesPublishings.length == 0){
    //   toast.error(`Please create deal rights for atleast one channel`, {
    //     position: toast.POSITION.TOP_RIGHT
    //   });
    //   return;
    // }

    if (user && user?.Channels?.length > 1 && seriesPublishings?.filter(x => x?.PlatformType?.SID == PLATFORMTYPE[0].SID)?.length == 0) {
      await setDefaultDealRights();
      return;
    }

    if (!isEdit) {
      await updateDefaultDealRights();
    }

    if (data.SID == 0 && !isManualAssetId) {
      data.AssetId = await DataHelper.getNewAssetId(localSeriesEntity.Content, true);
    }

    let res = await API.saveData(ENTITYNAME.Series, data);

    if (!res.success) {
      toast.error(res.message, {
        position: toast.POSITION.TOP_RIGHT
      });
    } else {

      //CREATE NEW SEASON AND EPISODES
      let newSeasonEpisodeRes = await createNewSeasonEpisode(res.data._id, data);
      if (newSeasonEpisodeRes) handleSetSeriesEntity(res.data, newSeasonEpisodeRes?.data?.Season);

      // Update season episode count
      await API.updateSeasonEpisodeCount({
        data: res.data, //series saved entity
        entityName: ENTITYNAME.Series
      });

      //ARCHIVE DATA FOR WHOLE SERIES 
      await saveArchiveChange();

      // ATTACH MEDIA TAB SAVE 
      await saveMediaInIsShorts();

      //OFFERS TAB SAVE
      await saveOffers(res.data);

      //PUBLISHING TAB SAVE OR CREATING DEAFAULT rights

      console.log(seriesPublishings);
      console.log(seriesPublishings.filter(x => x.PublishingSource == PUBLISHING_SOURCE.Series));


      let response = await API.updateMediaDealRights(
        res.data,
        removedMedia,
        seriesPublishings.filter(x => x.PublishingSource == PUBLISHING_SOURCE.Series),
        PUBLISHING_SOURCE.Series,
        seriesPublishings.length == 0
      );

      //OTT ASSET TAB SAVE
      let assetsData = {};
      if (assetDataItem.IsOttAsset) {
        let assetRes = await onAssetSubmit({ ...res.data, _id: series_id });
        if (assetRes.success) {
          assetsData = assetRes.data
        }
      }

      let logData = {
        event: localSeriesEntity.SID == 0 ? LOGEVENT.CREATE_PARENT_SERIES : LOGEVENT.UPDATE_PARENT_SERIES, module: MODULE.MEDIA_EPISODE_SERIES,
        data: { ...res.data, MediaDealRights: response?.data, _id: series_id, AttchMedia: selectedAttachedMedia, Assets: assetsData },
        message: res.message
      };
      API.SaveLogs(logData);

      toast.success("Saved Successfully", {
        position: toast.POSITION.TOP_RIGHT
      });

      if (props.quickEdit) {
        navigate(location.state.prevPath);
      } else {
        let findIndex = location?.state?.prevPath.indexOf("?");
        let pagination = location?.state?.prevPath?.slice(findIndex, location?.state?.prevPath?.length) ?? "";
        let state = {
          quickEdit: false,
          prevPath: location?.state?.prevPath ?? "/home/MediaEpisode/Series",
          pagination: location?.state.pagination ?? pagination,
          paths: location.state.paths
        }
        navigate(`/home/MediaEpisode/Series/${res.data.SID}`, { state: state });
      }

      setOpenSeason(true);
    }
  }

  const clear = () => {
    setSeriesEntity(blankDataItem);
  }



  const handleSetSeriesEntity = (data, seasonData) => {

    setSeriesEntity(data);

    let tempSeasonData = [];
    if (seasonData.length > 0) {
      seasonData.map((obj) => {
        tempSeasonData.push(obj.data);
      })
      setSeason(tempSeasonData);
    }

  }

  const handleSeriesPublishings = (data) => {
    setSeriesPublishings(data);
    setPublishingDialogTitle(null);
  }

  const handleSeriesOfferData = (data) => {
    setSeriesOffers(data);
  }

  const handleRemovePublishingData = (removedDataItem) => {
    setRemovedMedia(old => [...old, removedDataItem]);
  }

  const handleRemoveOfferData = (removedDataItem) => {
    setRemovedOffers(old => [...old, removedDataItem]);
  }


  const deleteSeason = async (index, dataItem) => {
    console.log(dataItem);

    setSeason((old) => old.filter((obj) => obj.SID != dataItem.SID));
    let res = await API.saveData(ENTITYNAME.Season, {
      ...dataItem,
      Series_Id: ''
    });
    if (!res.success) return;

  }

  const onSeasonEdit = (index, dataItem) => {
    console.log(dataItem);
    let findIndex = location?.state?.prevPath.indexOf("?");
    let state = {
      quickEdit: false,
      prevPath: location.pathname,
      pagination: location?.state?.prevPath?.slice(findIndex, location?.state?.prevPath?.length) ?? "",
      paths: [...location.state.paths, location.pathname]
    }
    navigate(`/home/MediaEpisode/Season/${dataItem.SID}`, { state: state });
  }

  const getSeriesMenu = (index, dataItem) => {
    return [
      {
        label: `${lang.options_actionbutton_menutext}`,
        items: [
          { label: `${lang.delete_actionbutton_option}`, icon: 'pi pi-fw pi-trash', command: () => { } },
          { label: `${lang.moveup_actionbutton_option}`, icon: 'pi pi-fw pi-arrow-up ', command: () => { } },
          { label: `${lang.movedown_actionbutton_option}`, icon: 'pi pi-fw pi-arrow-down', command: () => { } }
        ]
      }
    ]
  }

  const sideFixMenu = [
    {
      icon: 'play',
      title: `${lang.sidefix_season_tooltip}`,
      onClick: () => { setOpenSeason(old => !old) }
    },
  ]

  //asset
  const setAssetEntity = (entity) => {
    setAssetDataItem(entity)
  }

  function isValidAsset() {

    if (!assetDataItem.VodTypes || Object.keys(assetDataItem.VodTypes).length == 0) {
      toast.error(lang.please_select_vod_type_validation_error_message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }

    if ((assetDataItem.routeType == OTTROUTETYPE.Page || assetDataItem.routeType.Description == 'Page') && (assetDataItem.page_id == "" || assetDataItem.page_id == undefined)) {
      toast.error(lang.please_select_page, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }

    if (assetDataItem.Videos.length == 0) {
      toast.error(lang.please_attach_atleast_one_video_error_message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }

    if (assetDataItem.Posters.length == 0) {
      toast.error(lang.please_attach_atleast_one_poster_error_message, {
        position: toast.POSITION.TOP_RIGHT
      });
      return false;
    }

    return true;
  }

  const onAssetSubmit = async (seriesEntity) => {

    //MUTILANG TITLE & DESCRIPTION
    let title = assetDataItem.Title && assetDataItem.Title.length > 0 ? assetDataItem.Title : [
      {
        langISO: company.Language.ISOCode,
        value: mediaEpisodeEntity.Title
      }
    ];
    let description = assetDataItem.Description && assetDataItem.Description.length > 0 ? assetDataItem.Description : [
      {
        langISO: company.Language.ISOCode,
        value: assetDataItem.Description
      }
    ];

    const saveData = {
      Title: title,
      Description: description,
      TBA: assetDataItem.TBA ?? false,
      StartDate: assetDataItem.StartDate ? new Date(assetDataItem.StartDate).getTime() : new Date(moment(new Date()).format('YYYY-MM-DD')).getTime(),
      EndDate: assetDataItem.EndDate ? new Date(assetDataItem.EndDate).getTime() : new Date(moment(new Date()).add(1, 'M').format('YYYY-MM-DD')).getTime(),
      OttAssetTypeSID: ASSETTYPE['Media Asset'],
      Archive: assetDataItem.Archive ?? false,
      Source: { _id: seriesEntity._id, SID: seriesEntity.SID, Title: seriesEntity.Title, MediaCategory: seriesEntity.MediaCategory, entityName: 'series' },
      routeType: typeof assetDataItem.routeType === 'object' ? assetDataItem.routeType.ID : assetDataItem.routeType,
      page_id: typeof assetDataItem.page_id === 'object' ? assetDataItem.page_id._id : assetDataItem.page_id,
      VodTypes: {
        _id: assetDataItem.VodTypes._id,
        SID: assetDataItem.VodTypes.SID,
        Name: assetDataItem.VodTypes.Name
      },
      Provider: assetDataItem.Provider ? (typeof assetDataItem.Provider == "string") ? assetDataItem.Provider : assetDataItem.Provider?._id : "",
      Videos: assetDataItem.Videos ?? [],
      Posters: assetDataItem.Posters ?? [],
      RentalRetailPrice: assetDataItem.VodTypes.Name == 'TVOD' ? parseFloat(assetDataItem.RentalRetailPrice) : 0,
      RentalWholesalePrice: assetDataItem.VodTypes.Name == 'TVOD' ? parseFloat(assetDataItem.RentalWholesalePrice) : 0,
      WebAssets: assetDataItem?.WebAssets ? assetDataItem?.WebAssets?._id : "",
      accessLevel: assetDataItem?.accessLevel?._id ?? ACCESS_LEVEL.Both,
      Segments: (assetDataItem?.Segments && assetDataItem?.Segments?.length > 0) ? assetDataItem?.Segments?.map((x) => {
        return {
          _id: x?._id,
          Description: x?.Description
        }
      }) : []
    }

    if (assetDataItem._id != undefined) {
      saveData._id = assetDataItem._id;
      saveData.SID = assetDataItem.SID
    }

    console.log(saveData);

    let res = await API.saveData(ENTITYNAME.OttAsset, saveData);

    let logData = { event: res.message == "inserted" ? LOGEVENT.CREATE_ASSETS : LOGEVENT.UPDATE_ASSETS, module: MODULE.OTT_ASSETS, data: res.data, message: res.message };
    API.SaveLogs(logData);
    return res;
  };

  const onCancel = () => {

    if (seriesEntity.SID == 0) {

      ConfirmAlert(() => {
        if (location.state && location.state.prevPath) {
          navigate(location.state.prevPath)
        } else {
          navigate(-1) ? navigate(-1) : window.close();
        }
      }, () => { return; }, "Discard changes?", "Are you sure you want to discard changes?")
    } else {
      if (location.state && location.state.prevPath) {
        let state = {
          ...location.state,
          pagination: location.state.pagination ?? "",
          paths: location.state.paths.slice(0, -1)
        }
        navigate(location.state.paths.length == 1 ? location.state.paths.pop() + location.state.pagination ?? "" : location.state.paths.pop(), { state: state })
      } else {
        navigate(-1) ? navigate(-1) : window.close();
      }
    }
  }

  const handleMediaSelect = (dataList) => {
    //CHECK DUPLICATE 

    let duplicate = [];
    let toAdd = [];

    if (dataList.length > 0) {
      dataList.map((x) => {
        if (selectedAttachedMedia.some(y => y.SID == x.SID)) {
          duplicate.push(x.Title);
        } else {
          toAdd.push(x);
        }
      })
    }

    if (duplicate.length > 0) {
      toast.info(`${duplicate.join(',')} are already exists`, {
        position: toast.POSITION.TOP_RIGHT
      });
    }

    setSelectedAttachedMedia([...selectedAttachedMedia, ...toAdd]);


  }

  const saveMediaInIsShorts = async () => {

    // console.log(selectedAttachedMedia)
    if (selectedAttachedMedia.length == 0) return;

    for (const element of selectedAttachedMedia) {
      let item = element;

      let attachedMedia = {
        _id: seriesEntity._id,
        SID: SID,
        Title: seriesEntity.Title,
        MediaCategory: seriesEntity?.MediaCategory && Object.keys(seriesEntity?.MediaCategory).length > 0 ? {
          _id: seriesEntity?.MediaCategory?._id,
          SID: seriesEntity?.MediaCategory?.SID,
          Description: seriesEntity?.MediaCategory?.Description,
          isLong: seriesEntity?.MediaCategory?.isLong
        } : {},
        entityName: 'series'
      }

      let response = await API.saveData(ENTITYNAME.MediaEpisode, { _id: item._id, Media: attachedMedia });

      if (!response.success) {
        console.log(response)
      }

    }

  }

  const MyAttachMediaCommandCell = (props) => (
    <div style={{ display: "flex" }}>
      <DeleteRoundButton onClick={() => ConfirmDeleteAlert(() => deleteAttachedMedia(props.dataItem), () => { })} />
    </div>
  )

  const deleteAttachedMedia = async (dataItem) => {
    let filterMedia = selectedAttachedMedia.filter(x => x._id != dataItem._id);
    setSelectedAttachedMedia(filterMedia);

    let response = await API.saveData(ENTITYNAME.MediaEpisode, { _id: dataItem._id, Media: {} });
    if (!response.success) {
      console.log(response)
    }
  }

  //ON BOSS ASSISTANT ICON CLICK
  const onBossAIMetaDataLoad = async (item) => {

    let aiDataRes = await utility.loadDataViaBOSS_AI(BA_ACTION.FullMetaData, item, mediaEpisodeEntity);
    console.log(aiDataRes);
    return aiDataRes;

  }

  //FUNCTION FOR FETCHING META DATAFROM BOSS AI
  const setMetaData = (data) => {

    let newMetaData = {
      Title: data.Title,
      Description: data.Description,
      Synopsis: data.Synopsis && data.Synopsis.length > 0 ? data.Synopsis[0].Synopsis : "",
      Genres: genres.filter((x) => x.Description.toLowerCase() == data.Genre.toLowerCase()),
      SubGenres: genres.filter((x) => x.Description.toLowerCase() == data.SubGenre.toLowerCase()),
      ProductionYear: data.ProductionYear ?? '',
      Languages: data.Languages && data.Languages.length > 0 ?
        data.Languages.map((item) => { return languages.find((x) => x.Description && x.Description.toLowerCase() == item.toLowerCase()) }) : [],
      Keywords: data.Keywords ?? '',
      PGRating: pgRatings.find((x) => x.Description == data.PGRating) ? pgRatings.find((x) => x.Description == data.PGRating) : {},
      Categories: data?.Categories && data?.Categories?.length > 0 ? data?.Categories?.map((item) => {
        return {
          _id: item?._id,
          Name: item?.Name,
          parent: item?.parent
        }
      }) : []
    }
    setSeriesEntity({ ...seriesEntity, ...newMetaData });
    setMediaEpisodeEntity({ ...seriesEntity, ...newMetaData });
  }

  return (
    <>
      <div className="myFlexContainer" >

        <FixedSidebarWithIcons menuModel={sideFixMenu} />
        {openSeason && <CardList MenuModal={getSeriesMenu}
          close={() => setOpenSeason(false)}
          containerName="Destination"
          customeModelFields={customeModelFields}
          title={lang.series_cardlist_header}
          onAddClick={() => navigate("/home/MediaEpisode/Season/0", { state: { quickEdit: false, selectedSeries: seriesEntity, disableSelectSeries: true, existingSeason: season } })}
          posterURL="https://play-lh.googleusercontent.com/LsmwRk16eEuZXxYLc-FGARu72Ji1qQq3Ow5d0aQ6tX2JE_yAFwRVx0Ubuv5rWuhNnSEa=w480-h960-rw"
          cardData={season}
          showSearch={true}
          onEditDataItem={onSeasonEdit}
          onDeleteDataItem={deleteSeason}
          inTileView={false}
          showTileView={true}
          showPreferenceButton={true}
          columnEntityName={'season'} />}
        <div className="main-layout" >
          <EditPageHeader title={`${lang.series_sub_menu} -> ` + (seriesEntity.Title ? seriesEntity.Title : `${lang.new_button_dialog_header}`)} onSubmit={onSave} onCancel={onCancel} />
          <SeriesDetailForm
            dataItem={seriesEntity}
            setDataItem={setSeriesEntity}
            setSeriesData={handleSetSeriesEntity}
            quickEdit={location?.state?.quickEdit ?? false}
            setIsArchiveChanged={setIsArchiveChanged}
            isArchiveChanged={isArchiveChanged}
            createSeasonEpisode={createSeasonEpisode}
            setCreateSeasonEpisode={setCreateSeasonEpisode}
            onSave={onSave}
            isFromAddProgram={location?.state?.isFromAddProgram ?? false}
            isManualAssetId={isManualAssetId}
            setIsManualAssetId={setIsManualAssetId}
          />
          <Box sx={{ width: '100%', typography: 'body1' }}>
            <TabContext value={tabNumber}>
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                    <Tab label={lang.meta_data_label} value="1" />
                    <Tab label={lang.publishing_label} value="2" />
                    <Tab label={lang.ott_assets_collection_header} value="3" />
                    <Tab label={lang.attach_media_button_tooltip} value="4" />
                  </TabList>
                  <BossAssistantIcon
                    style={{}}
                    mediaEpisodeEntity={seriesEntity}
                    onDataLoad={onBossAIMetaDataLoad}
                    tooltip={"Generate full meta data with Boss AI"}
                    description={"BOSS AI Generating Meta Data"}
                    setMetaData={setMetaData}
                  />

                </Box>

              </Box>
              <TabPanel value={"1"}>
                {isLoadedEdit && <SeasonMetaDataEditForm dataItem={seriesEntity} setMataData={setMataData}/>}
              </TabPanel>
              <TabPanel value={"2"}>
                <MediaEpisodePublishingEditForm 
                  mediaCategory={mediaCategory.find((obj) => obj.SID == MEDIACATEGORIES.Series)} 
                  mediaEpisodeEntity={mediaEpisodeEntity} 
                  publishingSource={PUBLISHING_SOURCE.Series} 
                  data={seriesPublishings} 
                  handlePublishings={handleSeriesPublishings} 
                  handleRemovePublishingData={handleRemovePublishingData}

                  mediaOfferData={seriesOffers} 
                  handleOffers={handleSeriesOfferData} 
                  handleRemoveOfferData={handleRemoveOfferData}

                  openPublishingDialog={openPublishingDialog} 
                  setOpenPublishingDialog={setOpenPublishingDialog} 
                  defaultDealRight={defaultDealRight} 
                  isNewMedia={!isEdit} 
                  dialogtTitle={publishingDialogTitle} 
                />
              </TabPanel>
              <TabPanel value={"3"}>
                <div className="row mb-4" style={{ scrollbarWidth: "none", msOverflowStyle: 'none', overflow: 'auto', height: '63vh', boxShadow: "0px 0px 10px 1px lightgrey", backgroundColor: "#EEEEEE", borderRadius: "10px", padding: "13px 0px 15px 5px" }}>
                  <MediaEpisodeAssetEditForm source={'series'} sourceEntity={seriesEntity} entityname={ENTITYNAME.OttAsset} dataItem={assetDataItem} setDataEntity={setAssetEntity} setPotraitImageFiles={setPotraitImageFiles} setLandscapeImageFiles={setLandscapeImageFiles} selectedLanguage={company.Language} />
                </div>
              </TabPanel>
              <TabPanel value={"4"}>
                <div className="row" style={{ boxShadow: "0px 0px 10px 1px lightgrey", backgroundColor: "#EEEEEE", borderRadius: "10px", padding: "30px 20px 30px 20px" }}>
                  <RoundButton icon={'link'} title={lang.attach_media_button_tooltip} onClick={() => setMediaOpen(true)} />
                  <Grid data={selectedAttachedMedia} style={{ height: "30vh" }}>
                    <GridColumn cell={MyAttachMediaCommandCell} width={"40px"} locked={true} />
                    <GridColumn field="AssetId" title={lang.assetId_column} editable={false} />
                    <GridColumn field="Title" title={lang.title_column} editable={false} />
                  </Grid>
                </div>
              </TabPanel>
            </TabContext>
          </Box>

        </div>
      </div>
      {mediaOpen && <IsShortMediaCollectionSelection addButtonTitle={lang.select_button_text} title={lang.media_library_dialog_header} wherestatement={['MediaCategory.isLong', '=', false]} setDataList={handleMediaSelect} entityname={ENTITYNAME.MediaEpisode} closeForm={() => setMediaOpen(false)} width={"50vw"} height={"60vh"} />}
    </>)
};